// extracted by mini-css-extract-plugin
export default {"cls1":"CollapsedActivityPreview-cls1_Osn","cls2":"CollapsedActivityPreview-cls2_zBn CollapsedActivityPreview-cls1_Osn"};